module.exports = __webpack_public_path__ + "static/media/Instagram.40f245ca.svg";